<template>
  <transition name="modal">
    <form method="post" accept-charset="UTF-8" @submit="checkForm">
      <div class="modal-mask">
          <div class="modal-container">

            <div class="modal-header">
              <slot name="header">
                <h2>Edit Your Profile</h2>
              </slot>
            </div>

            <div class="modal-body">
              <slot name="body">
                <section class="member-profile">

                      <input type="hidden" :name="csrfTokenName" :value="csrfTokenValue">
                      <input type="hidden" name="action" value="users/save-user">
                      <input type="hidden" name="userId" :value="profile.id">
                      <input type="hidden" name="redirect" :value="redirecthash">

                      <div class="formfield formfield__first-name">
                          <label for="first-name">First Name *</label>
                          <input type="text" id="first-name" name="firstName" required v-model="profile.firstName">
                      </div>

                      <div class="formfield formfield__last-name">
                          <label for="last-name">Last Name *</label>
                          <input type="text" id="last-name" name="lastName" required v-model="profile.lastName">
                      </div>

                      <div class="formfield formfield__company-name">
                          <label for="company-name">Company Name</label>
                          <input type="text" id="company-name" name="fields[companyName]" v-model="profile.companyName">
                      </div>

                      <div class="formfield formfield__job-title">
                          <label for="job-title">Job Title</label>
                          <input type="text" id="job-title" name="fields[jobTitle]" v-model="profile.jobTitle">
                      </div>

                      <div class="formfield formfield__show-in-directory">
                          <input type="hidden" name="fields[showInMembersDirectory]" value="">
                          <input type="checkbox" id="show-in-directory" name="fields[showInMembersDirectory]" :checked="profile.showInDirectory" value="1">
                          <label for="show-in-directory">Show my details in the member's directory</label>
                      </div>

                      <div class="note">Need to change your email address? <a :href="emailLink">Please see this note</a>.</div>

                  </section>
              </slot>
            </div>

            <div class="modal-footer">
              <slot name="footer">
                <button @click.prevent="$emit('close')" style="float:right">
                  <span style="color:red; font-size:0.8em">Cancel</span>
                </button>

                <input style="margin-top:0" type="submit" :value="(loading?'Updating...':'Save changes')" :disabled="loading">

              </slot>
            </div>
        </div>
      </div>
    </form>

  </transition>

</template>

<script>
export default {
  data(){
    return {

      csrfTokenName:window.csrfTokenName,
      csrfTokenValue:window.csrfTokenValue,
      loading:false,
    }
  },
  props: ['profile','redirecthash','emailLink'],
  methods: {
    checkForm(){
      this.loading=true;
      return true;
    }
  }
}

</script>